import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";
import { useShowMenu } from "../context/ShowMenuContext";

const Menu = () => {
  const { setShowMenu } = useShowMenu();
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 118) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };

  return (
    <nav
      className={`main-menu main-menu-two clearfix ${
        isFixed ? "custom-fixed-menu" : ""
      }`}
    >
      <div className="main-menu-two-wrapper clearfix">
        <div className="container clearfix">
          <div className="main-menu-two-wrapper-inner clearfix">
            <div className="main-menu-two-wrapper__main-menu">
              <Link
                to="#"
                className="mobile-nav__toggler"
                onClick={() => {
                  setShowMenu(true);
                }}
              >
                <i className="fa fa-bars"></i>
              </Link>
              <ul className="main-menu__list">
                <li className="dropdown megamenu">
                  <Link to="/" onClick={() => linkClicker("")}>
                    Home
                  </Link>
                </li>
                <li className="dropdown megamenu">
                  <Link to="/about" onClick={() => linkClicker("about")}>
                    About
                  </Link>
                </li>
                <li className="dropdown megamenu">
                  <Link to="/council" onClick={() => linkClicker("council")}>
                    The Council
                  </Link>
                </li>
                <li className="dropdown">
                  <Link to="#">News & Events</Link>
                  <ul>
                    <li>
                      <Link to="/events" onClick={() => linkClicker("events")}>
                        Events
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/news-letter"
                        onClick={() => linkClicker("news-letter")}
                      >
                        News Letter
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <Link to="#">Members Area</Link>
                  <ul>
                    <li>
                      <Link
                        to="/become-a-member"
                        onClick={() => linkClicker("become-a-member")}
                      >
                        Become a Member
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/benefits-of-member"
                        onClick={() => linkClicker("benefits-of-member")}
                      >
                        Benefits of a Member
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/list-of-all-member"
                        onClick={() => linkClicker("list-of-all-member")}
                      >
                        List of All Members
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <Link to="#">Surgical Domains</Link>
                  <ul>
                    <li className="dropdown">
                      <Link to="#">Overview</Link>
                      <ul>
                        <li>
                          <Link
                            to="/types-of-facial-plastic-surgery"
                            onClick={() =>
                              linkClicker("types-of-facial-plastic-surgery")
                            }
                          >
                            Types of Facial Plastic Surgery
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/who-is-a-facial-plastic-surgeon"
                            onClick={() =>
                              linkClicker("who-is-a-facial-plastic-surgeon")
                            }
                          >
                            Who is a Facial Plastic Surgeon
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Nose</Link>
                      <ul>
                        <li>
                          <Link
                            to="/rhinoplasty"
                            onClick={() => linkClicker("rhinoplasty")}
                          >
                            Rhinoplasty
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Eyelids</Link>
                      <ul>
                        <li>
                          <Link
                            to="/lower-blepharoplasty"
                            onClick={() => linkClicker("lower-blepharoplasty")}
                          >
                            Lower Blepharoplasty
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/upper-blepharoplasty"
                            onClick={() => linkClicker("upper-blepharoplasty")}
                          >
                            Upper Blepharoplasty
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Lifts</Link>
                      <ul>
                        <li>
                          <Link
                            to="/face-lift"
                            onClick={() => linkClicker("face-lift")}
                          >
                            Face Lift
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/fore-head-lift"
                            onClick={() => linkClicker("fore-head-lift")}
                          >
                            ForeHead Lift
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Chin & Ears</Link>
                      <ul>
                        <li>
                          <Link
                            to="/mentoplasty"
                            onClick={() => linkClicker("mentoplasty")}
                          >
                            Mentoplasty
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/otoplasty"
                            onClick={() => linkClicker("otoplasty")}
                          >
                            Otoplasty
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Skin</Link>
                      <ul>
                        <li>
                          <Link
                            to="/scar-revision"
                            onClick={() => linkClicker("scar-revision")}
                          >
                            Scar Revision
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/skin-cancer"
                            onClick={() => linkClicker("skin-cancer")}
                          >
                            Skin Cancer
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/skin-peels"
                            onClick={() => linkClicker("skin-peels")}
                          >
                            Skin Peels
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Injectables</Link>
                      <ul>
                        <li>
                          <Link
                            to="/botulinum-toxin"
                            onClick={() => linkClicker("botulinum-toxin")}
                          >
                            Botulinum Toxin
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Lipoplasty</Link>
                      <ul>
                        <li>
                          <Link
                            to="/fat-grafting"
                            onClick={() => linkClicker("fat-grafting")}
                          >
                            Fat Grafting
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                {/* <li className="dropdown">
                  <Link to="#">Academics</Link>
                  <ul>
                    <li>
                      <Link to="/fellowship" onClick={() => linkClicker("fellowship")}>
                        Fellowship
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/observership"
                        onClick={() => linkClicker("observership")}
                      >
                        Observership
                      </Link>
                    </li>
                  </ul>
                </li> */}
                <li>
                  <Link to="/gallery" onClick={() => linkClicker("gallery")}>Gallery</Link>
                </li>
                <li>
                  <Link to="/archive" onClick={() => linkClicker("archive")}>
                    Archive
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={() => linkClicker("contact")}>
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div className="main-menu-two-wrapper__right">
              <div className="main-menu-two__top-social">
                 <Link to="#">
                  <i className="fab fa-twitter"></i>
                </Link>
                 <Link to="#">
                  <i className="fab fa-facebook"></i>
                </Link>
                 <Link to="#">
                  <i className="fab fa-pinterest-p"></i>
                </Link>
                 <Link to="#">
                  <i className="fab fa-instagram"></i>
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
